<template>
  <ContainerFixed>
    <div class="ui segments raised">
      <CardTitle
        title="Upload Banner Login"
        icon-class="file alternate outline icon"
        title-class="ui green large ribbon label"
      >
      </CardTitle>
      <ContainerBody>
        <div class="fields">
          <Input
            v-model="descricao_arquivo"
            name="descricao_arquivo"
            label="Descrição"
            size="five"
            validation-rules="required"
          />
          <Autocomplete
            label="Tipo"
            name="Tipo"
            v-model="tipo"
            :items="['Foto']"
            size="four"
          />
          <InputUpload
            ref="inputUpload"
            v-model="arquivo"
            name="arquivo"
            validation-rules="required"
            label="Arquivo"
            size="six"
            programa="scp000a1"
            :value="arquivo.nomeArquivo"
            :mostrarBotaoBaixar="true"
            :mostrarBotaoRemover="true"
            :mostrarBotaoEdicao="false"
            :mostrarBotaoUpload="true"
            :autoProcessQueue="false"
          />
          <div class="three wide field">
            <BlankLabel />
                <button
                  type="button"
                  class="ui icon button green compact fluid "
                  @click="save"
                >
                  <i class="icon save" /> Salvar
                </button>
          </div>
        </div>
        <div class="sixteen wide column">
          <SimpleTable
            v-if="tableData.length"
            :headers="tableHead"
            :items="tableData"
          />
        </div>
      </ContainerBody>
    </div>
    <SimpleModal
      title="Upload Imagem"
      :alerta="alertError"
    >
    </SimpleModal>
    <ModalAlert
      :title="alertTitle"
      :text="alertMessage"
      :erros="errors"
    />
  </ContainerFixed>
</template>

<script>

import ContainerFixed from '@/components/ContainerFixed.vue';
import ContainerBody from '@/components/ContainerBody.vue';
import CardTitle from '@/components/CardTitle.vue';
import SimpleTable from '@/components/SimpleTable.vue';
import Button from '@/components/Button.vue';
import Input from '@/components/Input.vue';
import SimpleModal from '@/components/SimpleModal.vue';
import InputUpload from '@/components/InputUpload.vue';
import BlankLabel from '@/components/BlankLabel.vue';
import Autocomplete from '@/components/Autocomplete.vue';
import ModalAlert from '@/components/ModalAlert.vue';

import { ValidationObserver } from 'vee-validate';

import api from '@/services/api';
import moment from 'moment';

export default {
  name: 'UploadImagemLogin',
  components: {
    ContainerFixed,
    ContainerBody,
    CardTitle,
    SimpleTable,
    SimpleModal,
    Input,
    InputUpload,
    BlankLabel,
    ModalAlert,
    Autocomplete,
  },
  data() {
    return {
      listaAnexos: [],
      dadosfiliais: [],
      tableHead: [
        { text: 'Código', value: 'idanexo' },
        { text: 'Descrição', value: 'nomearq' },
        { text: 'Data Upload', value: 'data' },
        { text: 'Opções', value: 'buttons', buttons: true },
      ],
      tableData: [],
      alertError: '',
      modalConsulta: false,
      erroConsulta: '',
      tipo: null,
      resultadoConsulta: '',
      mostraIntegrar: false,
      theme: localStorage.getItem('theme') == 'dark' ? 'dark' : false,
      item: [1],
      descricao_arquivo: null,
      arquivo: {
        nomeArquivo: '',
        idArquivo: '',
        recnumArqanex: 0,
      },
      alertMessage: '',
      alertTitle: 'Atenção',
      errors: [],
    };
  },
  async created() {
    this.renderTable();
  },
  mounted() {
    this.listarAnexos();
  },
  methods: {
    async renderTable() {
      this.$store.commit('global/loading');
      await api.get('api/banners')
        .then(result => {
          this.tableData = result.data.reduce((itens, item) => {
            const buttons = [
              { text: 'Visualizar', class: 'ui label green small', click: () => this.visualizaImagem(item.recnum) },
              { text: 'X', class: 'ui label red small remove icon', click: () => this.delete(item.recnum) },
            ];
            itens.push({
              ...item,
              datainclusao: moment(item.data).format('DD/MM/YYYY'),
              buttons,
            });
            return itens;
          }, []);
          this.$store.commit('global/loaded');
        })
        .catch(() => {
          this.$store.commit('global/loaded');
        });
    },
    formatarData(value) {
      return moment(value).format('DD/MM/YYYY HH:mm:ss');
    },
    async listarAnexos() {
      this.$store.commit('global/loading');

      await api.get('/api/banners')
        .then((result) => {
          const dados = result.data.reduce((itens, item) => {
            itens.push({ id: item.idanexo, descricao: item.nomearq, recnum: item.recnum });
            return itens;
          }, []);
          this.listaAnexos = dados;
          this.$store.commit('global/loaded');
        });
    },
    async delete(recnum) {
      this.$alertify.confirm(
        'Deseja realmente Excluir o Registro?',
        async () => {
          this.$store.commit('global/loading');
          try {
            await api.delete(`/api/banners/${recnum}`);
            this.renderTable();
          } catch (error) {
            this.alertMessage.error(error.response.data.message);
          } finally {
            this.$store.commit('global/loaded');
          }
        },
        () => true,
      );
    },
    async visualizaImagem(recnum) {
      this.$store.commit('global/loading');
      let link = null;
      try {
        link = await api.get(`/api/banners/link/${recnum}`);
        window.open(link.data, '_blank');
      } catch (error) {
        this.alertMessage.error('error.response.data.message');
      } finally {
        this.$store.commit('global/loaded');
      }
    },
    limparCampos() {
      this.descricao_arquivo = null;
      this.tipo = null;
      this.arquivo.nomeArquivo = '';
      this.arquivo.idArquivo = '';
      this.arquivo.recnumArqanex = 0;
    },
    async save() {
      this.errors = [];
      this.$store.commit('global/loading');
      try {
        const dados = {
          idregistro: (this.tipo == 'Foto' ? 1 : 2),
          nomearq: this.descricao_arquivo,
          recnumarquivo: this.arquivo.recnumArqanex,
        };
        const result = await api.post('api/banners', dados);
        if (result.erro) {
          this.alertMessage = result.data.mensagem;
          this.alertTitle = 'Erro';
          this.$store.commit('global/openAlert');
          this.$store.commit('global/loaded');
        } else {
          this.$store.commit('global/loaded');
          this.renderTable();
          this.limparCampos();
        }
      } catch (error) {
        this.alertTitle = 'Erro';
        this.alertMessage = '';
        if (error.response.data.errors) {
          this.alertTitle = 'Rejeitado';
          this.alertMessage = error.response.data.message;
          this.errors = Object.keys(error.response.data.errors).map(item => ({
            texto: error.response.data.errors[item].join(),
          }));
        }
        this.$store.commit('global/openAlert');
      }
      this.$store.commit('global/loaded');
    },
  },
};
</script>

<style lang="scss">
  .box-json {

    .json {
      background-color: #282a36;
      color: #fff;
      white-space: break-spaces;
    }
  }
</style>
